import React from "react";
import {
  CheckCircle,
  XCircle,
  TrendingUp,
  Brain,
  Calculator,
} from "lucide-react";

const QuestionTypeAnalysisSection = ({ questionTypeData }) => {
  const getQuestionTypeIcon = (type) => {
    const icons = {
      numerical: Calculator,
      theoretical: Brain,
      conceptual: Brain,
      application: TrendingUp,
    };

    return icons[type] || Brain;
  };

  const cards = [
    {
      title: "Strongest",
      icon: CheckCircle,
      iconColor: "text-emerald-600",
      bg: "bg-emerald-50",
      border: "border-emerald-200",
      bar: "bg-emerald-500",
      data: questionTypeData.strongest,
    },
    {
      title: "Focus Area",
      icon: XCircle,
      iconColor: "text-amber-600",
      bg: "bg-amber-50",
      border: "border-amber-200",
      bar: "bg-amber-500",
      data: questionTypeData.weakest,
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      {/* Header */}
      <div className="mb-4">
        <h2 className="font-semibold text-gray-900">Question Type Analysis</h2>
      </div>

      {/* Strongest / Weakest */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
        {cards.map((card) => {
          const TypeIcon = getQuestionTypeIcon(card.data?.questionType);

          return (
            <div
              key={card.title}
              className={`${card.bg} ${card.border} border rounded-lg p-3`}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <card.icon className={`w-4 h-4 ${card.iconColor}`} />

                  <span className="text-sm font-medium text-gray-700">
                    {card.title}
                  </span>
                </div>

                <span className={`text-sm font-bold ${card.iconColor}`}>
                  {card.data?.accuracy}%
                </span>
              </div>

              <div className="flex items-center gap-2 mb-2">
                <TypeIcon className={`w-4 h-4 ${card.iconColor}`} />

                <span className="font-semibold text-gray-900 capitalize">
                  {card.data?.questionType}
                </span>
              </div>

              <div className="flex justify-between text-xs text-gray-600 mb-2">
                <span>{card.data?.totalQuestions} Questions</span>

                <span>Accuracy: {card.data?.accuracy}%</span>
              </div>

              <div className="h-1.5 bg-white rounded-full overflow-hidden">
                <div
                  className={`${card.bar} h-full rounded-full transition-all duration-500`}
                  style={{
                    width: `${card.data?.accuracy}%`,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>

      {/* Insight */}
      <div className="px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="text-sm font-medium text-blue-900">
          {questionTypeData.title}
        </div>

        <p className="text-xs text-blue-700 mt-1">
          {questionTypeData.description}
        </p>
      </div>
    </div>
  );
};

export default QuestionTypeAnalysisSection;
